// Tiny cookie-backed key/value store for UI preferences.
//
// We migrated off localStorage per code-review hardening even though the data
// stored here is non-sensitive (theme, active dashboard timeframe, etc.). The
// cookie path keeps UI state working under privacy modes that disable
// localStorage, and consolidates browser-state into one place we already
// emit on every request.
//
// All values are URL-encoded and stored under `uptick.<key>` with a 1-year
// expiry, Path=/, SameSite=Lax. We avoid `Secure` so dev (http localhost)
// still works; in the preview env all traffic is HTTPS anyway.
//
// Values pass through JSON.stringify/parse so callers can store small arrays
// + plain objects in addition to strings/booleans.

const PREFIX = "uptick.";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

function isBrowser() {
  return typeof document !== "undefined";
}

export function getPref(key, fallback = null) {
  if (!isBrowser()) return fallback;
  const name = `${PREFIX}${key}=`;
  const raw = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name));
  if (!raw) return fallback;
  try {
    return JSON.parse(decodeURIComponent(raw.slice(name.length)));
  } catch (e) {
    console.warn(`getPref: malformed cookie for ${key}`, e);
    return fallback;
  }
}

export function setPref(key, value) {
  if (!isBrowser()) return;
  const encoded = encodeURIComponent(JSON.stringify(value));
  document.cookie = `${PREFIX}${key}=${encoded}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax`;
}

export function removePref(key) {
  if (!isBrowser()) return;
  document.cookie = `${PREFIX}${key}=; Path=/; Max-Age=0; SameSite=Lax`;
}
